module.exports = __webpack_public_path__ + "system/img/defd.e217a19e.png";